import React from 'react';
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import Slide from 'react-reveal/Slide';
const About = () => {
    return (
        <div id = "about">
            <Container>
                <Row className="mt-5">
                    <Col md={5}>
                      {/* <GreetingLottie animationPath="/lottie/coding.json" /> */}
                      <Slide left >
                      <lottie-player src="https://assets5.lottiefiles.com/packages/lf20_iv4dsx3q.json"  background="transparent"  speed="1"  style={{width: '100%', height: '90%'}}  loop  autoplay></lottie-player>
                      </Slide>
                    </Col>
                    <Col md={7}>
                    <Slide right >
                    <p className="home-about-body">
              I fell in love with programming and I have started learning programming since than.
              <br />
              <br />I am fluent in 
              <i>
                <b className="purple">  Javascript </b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> 
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with 
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Framework
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js</b>
              </i>
              <br />
              <br />
              
             
            </p>
            </Slide>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default About;
